<template>
  <div class="LipCheck">
    <div class="container">
      <van-popup
        v-model="show"
        style="background-color: transparent;"
      >
        <van-loading
          size="24px"
          vertical
        >人脸识别验证中...</van-loading>
      </van-popup>
      <div
        class="ranpage"
        style="display: block"
      >
        <p class="plsRem">
          请记住以上<span>4位验证码</span>，录制视频时，<span>依次匀速朗读</span>
        </p>
        <div class="labelsBox">
          <p
            class="labels"
            id="ranNum"
            v-text="num"
          ></p>
        </div>
        <input
          style="display:none"
          id="file"
          name="file"
          type="file"
          accept="video/*"
          capture="camera"
          @change="startVideo"
          ref="video"
        />
      </div>

      <div class="small_tops">
        <img
          src="@/assets/images/lip_icon.png"
          alt=""
        />
      </div>
      <div class="bt_view">
        <div
          class="button"
          @click="beginVideo"
          v-if="!isPc"
        >
          <p class="bt_text">开始验证</p>
        </div>
        <span v-else style="font-weight: bold;">人脸识别操作请在手机端完成</span>
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import service from '@/request/api'; // 导入api接口
import { checkStatus } from '../commonPage/mixin';
import ServerBank from '@/components/ServerBank.vue';

export default {
  name: 'LipCheck',
  data() {
    return {
      num: '',
      show: false,
      scanToken: '',
      orderId: '',
      productId: '',
      isPc: false,
    };
  },
  created() {
    const { orderId, productId } = this.$route.query;
    this.orderId = orderId;
    this.productId = productId;
    this.getRandomNum(orderId);
    this.autoExp();
  },
  mixins: [checkStatus],
  components: {
    ServerBank,
  },
  methods: {
    autoExp(){
      let np = navigator.platform;
      if(['SPDB-FPD', 'SPDB-YQD', 'SPDB-PHD'].includes(this.productId) && (np.indexOf('Win') === 0 || np.indexOf('Mac') === 0)) {
          this.isPc = true;
      }
    },
    getRandomNum(orderId) {
      console.log('orderId', orderId);
      service.CommonForms.getRandomNumber({ orderId }).then((res) => {
        if (res.success) {
          this.num = res.data.label;
          this.scanToken = res.data.token;
        } else {
          Toast('获取语音验证码失败！');
        }
      });
    },
    beginVideo() {
      this.$refs.video.click();
    },
    jumpPage() {
      service.CommonForms.jumpThirdServer({ orderId: this.orderId }).then(
        // eslint-disable-next-line no-shadow
        (res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            Toast(res.returnMessage);
          }
          setTimeout(() => {
            this.show = false;
          }, 2000);
        },
      );
    },
    nextStep() {
      service.CommonForms.nextJumpPageServer({
        orderId: this.orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success && res.data) {
          window.location.href = res.data;
        } else {
          Toast(res.returnMessage);
        }
      }).catch((e) => {
        Toast('系统异常，请稍后再试');
      });
    },
    startVideo(e) {
      this.show = true;
      const file = e.target.files[0];
      if (file == null || file === 'undefined') {
        return;
      }
      if (file.size / 1024 / 1024 > 20) {
        Toast('视频不能超过20M,请重新上传');
        // eslint-disable-next-line consistent-return
        return false;
      }
      const data = new window.FormData();
      data.append('file', file);
      data.append('label', this.num);
      data.append('token', this.scanToken);
      data.append('orderId', this.orderId);
      service.CommonForms.setLipCheck(data).then((res) => {
        if (res.success) {
          service.OtherPage.grantBookCont({ orderId: this.orderId }).then(
            // eslint-disable-next-line no-shadow
            (res) => {
              if (res.success) {
                this.nextStep();
              } else {
                this.$router.push(`/supermarket/v2/authorizationAgreement?orderId=${this.$route.query.orderId}&productId=${this.$route.query.productId}&returnMessage=${res.returnMessage}`);
                this.show = false;
              }
            },
          );
        } else {
          Dialog.alert({
            message: '人脸识别验证失败，请重新验证',
          }).then(() => {
            this.getRandomNum(this.orderId);
          });
          this.show = false;
        }
        this.$refs.video.value = '';
      });
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}

/** 以下是首页 **/
.container {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}

/* @media screen and (min-width: 420px) {
  .container {
    position: absolute;
    top: 0;
    width: 360px;
    height: 640px;
    overflow: hidden;
    background: #030e27;
  }
} */

/** 按钮view **/
.bt_view {
  position: absolute;
  bottom: 146px;
  width: 100%;
  height: 100px;
  text-align: center;
}

/** button **/
.button {
  display: block;
  width: 80%;
  height: 44px;
  margin: 0 auto;
  margin-top: 12%;
  line-height: 44px;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 2em;
  border-radius: 8px;
}

.bt_text {
  color: #fff;
  font-size: 17px;
}

.bg {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

.ranpage {
  position: absolute;
  top: 25px;
  box-sizing: border-box;
  width: 100%;
  height: 45%;
  text-align: center;
  background: #f5f5f5;
}

.small_tops {
  position: absolute;
  top: 45%;
  width: 100%;
  height: 63px;
  text-align: center;
}

.small_tops img {
  width: 90%;
  height: 100%;
}

.labelsBox {
  width: 90%;
  height: 140px;
  margin: 25px auto 0 auto;
  color: #ff6538;
  font-size: 40px;
  letter-spacing: 0.2em;
}

.plsRem {
  color: #525867;
  font-size: 12px;
  letter-spacing: 0;
}

.plsRem span {
  color: #00121a;
}
</style>
